import { useTranslation } from "react-i18next";
import cajuQualidade from "../../../assets/qualidade.jpg";
import logo from "../../../assets/logo.png";

export default function Qualidade() {
  const { t } = useTranslation();
  return (
    <section id="qualidade-section">
      <div className="imagem-texto">
        <h1>{t("nos.qualidade.titulo")}</h1>
        <img src={logo} alt="Logo GranCaju" />
      </div>
      <div className="content">
        <div className="flex">
          <img src={cajuQualidade} alt="Castanhas" />
          <p>{t("nos.qualidade.descricao.p1")}</p>
        </div>
        <p>
          {t("nos.qualidade.descricao.p2")}
          <br />
          {t("nos.qualidade.embalagens.p1")}
          <br />
          {t("nos.qualidade.embalagens.p2")}
          <br />
        </p>
        <p
          dangerouslySetInnerHTML={{ __html: t("nos.qualidade.embalagens.p3") }}
        />
        <p>{t("nos.qualidade.embalagens.p4")}</p>
        <p>{t("nos.qualidade.embalagens.p5")}</p>
      </div>
    </section>
  );
}
